export default {
  // Reviews
  "edit_review": "レビューを編集",
  "review": "レビュー",
  "film_friendly_score": "フィルムフレンドリースコア",
  "hand_check": "手動チェック",
  "successful": "成功",
  "unsuccessful": "不成功",
  "delete_review": "レビューを削除",
  "review_by": "レビュー作成者：",
  "Terminal": "ターミナル",
};
